import { scrollIntoView } from "../helpers/scroll-into-view";

const createError = (text) => {
    let error = document.createElement('div');
    error.textContent = text;
    error.setAttribute("data-feedback-temp", "");
    error.className = "feedback feedback--error";

    return error;
}

const showCommonErrors = (form, errors) => {
    let fragment = document.createDocumentFragment();

    errors.forEach(error => {
        let errorElement = createError(error);
        fragment.appendChild(errorElement);
    });

    let container = form.querySelector('[data-form-errors]');
    if (container) container.appendChild(fragment);
    else form.insertBefore(fragment, form.firstElementChild);
}

const showErrors = (form, errors) => {
    hideErrors(form);
    
    let commonErrors = [];

    for (let fieldName in errors) {
        /* Готовый элемент для вывода ошибки */
        let defaultElement = form.querySelector(`[data-feedback="${fieldName}"]`);

        if (defaultElement) {
            defaultElement.textContent = errors[fieldName];
            defaultElement.classList.remove("hidden");
            defaultElement.classList.add("feedback", "feedback--error");

            let parent = defaultElement.closest('[data-form-field]');
            if (parent) parent.classList.add('has-errors');
        } else {
            /* Вывод ошибки под полем */
            let fields = form.querySelectorAll(`[name="${fieldName}"], [name="${fieldName}[]"]`);
            if (fields.length) {
                let lastField = fields[fields.length - 1];
                let errorElement = createError(errors[fieldName]);
                lastField.parentElement.insertBefore(errorElement, lastField.nextElementSibling);

                let parent = lastField.closest('[data-form-field]');
                if (parent) parent.classList.add('has-errors');
            } else {
                /* Вывод ошибки над формой */
                commonErrors.push(errors[fieldName]);
            }
        }
    }

    form.classList.add('has-errors');

    showCommonErrors(form, commonErrors);

    
    let firstError = form.querySelector('.has-errors');
    if (!firstError) firstError = form;

    scrollIntoView(firstError);
    
};

const showErrorsByNames = (form, errors, rules) => {
    for (let field in errors) {
        if (errors.hasOwnProperty(field)) {
            let ruleName = errors[field];

            let message = ruleName;

            let fieldRules = rules[field];
            if (fieldRules) {
                let ruleMessage = rules[field].messages[ruleName];
                if (ruleMessage) message = ruleMessage;
            }

            if (message) errors[field] = message;
        }
    }

    showErrors(form, errors);
};

const hideErrors = (form) => {
    let errorElements = Array.from(form.querySelectorAll("[data-feedback]"));
    let tempErrorElements = Array.from(form.querySelectorAll("[data-feedback-temp]"));
    let errorFields = Array.from(form.querySelectorAll(".has-errors"));

    errorElements.forEach(el => {
        el.innerHTML = "";
        el.classList.add('hidden');
    });

    tempErrorElements.forEach(el => el.remove());

    errorFields.forEach(field => field.classList.remove('has-errors'));
};

export { showErrors, showErrorsByNames, hideErrors, showCommonErrors };